import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import global_en from './translations/en/global.json';
import global_de from './translations/de/global.json';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { initializeBundleId } from './BundleIdCookie';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      global: global_en,
    },
    de: {
      global: global_de,
    },
  },
});

const startApp = async () => {
  try {
    await initializeBundleId();
    const container = document.getElementById('root');
    if (!container) {
      throw new Error('Root container not found');
    }

    const root = createRoot(container);
    root.render(
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>,
    );
  } catch (error) {
    console.error('Error during app initialization:', error);
  }
};

// Start the app
startApp();
